export interface ContactModel {
  id: number;
  firstName: string;
  lastName: string;
  nickname: string;
  title: string;
  statusId: number;
  status: string;
  phoneCell: string;
  phoneOffice: string;
  city: string;
  state: string;
  zip: string;
  compact: string;
  email: string;
  facilityName: string;
  receiveSMSBroadcast: boolean;
  receiveEmailBroadcast: boolean;
  contactType: ContactType;
}

export interface ContactGroupModel {
  id: number,
  contactCount: number,
  groupName: string,
}

export enum ContactType {
  Provider = 1,
  FacilityContact = 2
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/communications/models/contactModel.ts